<script setup>
import { computed } from 'vue'
import { ArrowTopRightOnSquareIcon } from '@heroicons/vue/20/solid'

const props = defineProps({
  /**
   * The available button style variants - primary, secondary, cancel
   */
  variant: {
    type: String,
    default: 'primary',
    validator(e) {
      return ['primary', 'secondary', 'tertiary'].includes(e)
    },
  },

  /**
   * Link's 'href' attribute value
   */
  href: String,

  /**
   * Link's 'target' attribute value
   */
  target: String,

  /**
   * Enable visited functionality
   */
  visited: Boolean,

  /**
   * Does the link lead to an external location
   */
  external: Boolean,

  /**
   * The text to display if the default slot isn't used
   */
  label: String,
})

const classes = computed(() => {
  switch (props.variant) {
    case 'primary':
      return 'text-blue'
    case 'secondary':
      return 'text-white'
    case 'tertiary':
      return 'text-[#3D2669]'
    default:
      return ''
  }
})
</script>

<template>
  <a
    :href="props.href"
    class="underline decoration-1 underline-offset-2 hover:decoration-2 focus:outline-none focus:bg-yellow focus:decoration-2 focus:text-black"
    :class="[classes, visited ? 'visited:text-indigo' : '']"
    :target="target"
  >
    <slot v-if="$slots.default" />
    <span
      v-else
      class="flex items-center"
    >
      {{ label }}
      <ArrowTopRightOnSquareIcon
        v-if="external"
        class="h-5 w-5 ml-1"
        aria-hidden="true"
      />
    </span>
  </a>
</template>
